module.exports = __webpack_public_path__ + "img/bg-bean-03.3bd61e44.png";